import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import { MEMBER_TERM_ATTENDANCE_LIST } from "../../graphQL/member";
import { GET_CLIENT_UUID } from "../../graphQL/client_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  selectStyle: {
    minWidth: 200,
    height: 35,
    paddingRight: 16,
    marginBottom: 25,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
}));

export default function MemberAttendanceInfoDialog({
  closeDialog,
  fullName,
  userUuid,
  termUuid,
  termName,
  termTeams,
  termRoles,
  teamTermMemberIds
}) {
  let termsList = [];
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [selectedRow, setSelectedRow] = useState(userUuid);
  const [eventsList, setEventsList] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);
  const [selectedVal, setSelectedVal] = useState("Select");
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part
  let clientId = 1;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");
  let tenantId = 1;
  if (localStorage.getItem("tenantId"))
    tenantId = localStorage.getItem("tenantId");
    
  const [getMemberTermAttendanceQuery] = useManualQuery(MEMBER_TERM_ATTENDANCE_LIST);

  const handleChangeValue = async (event) => {
      const {
        loading: loadingData,
        error: errorData,
        data: dataList,
      } = await getMemberTermAttendanceQuery({
        variables: {
          teamTermMemberId: parseInt(event.target.value),
        },
      });

      if (!loadingData && dataList) {
        let tmp = [];
        console.log(dataList);
        for (var i in dataList.getMemberTermAttendance) {
            let attendance = dataList.getMemberTermAttendance[i];
            let data = {};
            data["id"] = attendance.teamTermEventId.teamTermEventId;
            data["period"] = attendance.teamTermEventId.teamTermPeriodId.name;
            data["event"] = attendance.teamTermEventId.name;
            data["desc"] = attendance.teamTermEventId.desc;
            data["actualDate"] = dayFormat(attendance.teamTermEventId.actualDate);
            data["scheduledDate"] = dayFormat(attendance.teamTermEventId.scheduledDate);
            data["eventType"] = attendance.teamTermEventId.eventTypeId.name;
            data["attended"] = attendance.attended === true ? "Yes" : "No";
            tmp.push(data);
        }
        setEventsList(tmp);
        console.log(tmp);
        setLoadData(true);
      }
      if (errorData) {
          console.log(errorData);
          if (errorData.graphQLErrors[0].message === "Signature has expired")
            navigate(`${project_url}/signin/?next=${pathname}`);
      }
  };
  
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  const dayFormat = day => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
    }
    return newFormat;
  };
  
  useEffect(() => {
    handleChangeValue({ target: { value: teamTermMemberIds[0] } });
  }, [termTeams, teamTermMemberIds]);
  
  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  
  function CustomNoRowsOverlay() {
    return (    
      <Box sx={{ mt: 2 }}>There is no event that requires any member's attendance</Box>
    );
  }
  
  const columns = [
    {
      field: "period",
      headerClassName: "super-app-theme--header",
      headerName: "Period",
      minWidth: 150,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    
    {
      field: "event",
      headerName: "Event",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    
    {
      field: "eventType",
      headerName: "Event Type",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    
    {
      field: "description",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "scheduledDate",
      headerClassName: "super-app-theme--header",
      headerName: "Scheduled Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    
    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    
    {
      field: "attended",
      headerClassName: "super-app-theme--header",
      headerName: "Member Attended?",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  
  const rows = eventsList
    .map((trm, index) => ({ 
      index,
      id: trm.id,
      period: trm.period,
      event: trm.event,
      eventType: trm.eventType,
      desc: trm.desc,
      scheduledDate: trm.scheduledDate,
      actualDate: trm.actualDate,
      attended: trm.attended,
  }));
  
  return (
    <div>
      <Dialog disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "1100px",
              height: "700px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Member Term Attendance
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
            <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
              <b>Member:</b> {fullName}
            </Typography>
            <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
              <b>Term:</b> {termName}
            </Typography>
            <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
              <b>Team: </b>
               {termTeams.length === 1 ? (
                <>
                  {termTeams[0]} / {termRoles[0]}
                </>
                ) : (
              <Select
                className={classes.selectStyle}
                defaultValue={teamTermMemberIds[0]}
                margin="normal"
                onChange={handleChangeValue}
              >
                {termTeams.map((team, index) => (
                  <MenuItem key={index} value={teamTermMemberIds[index]}>
                    {team} / {termRoles[index]}
                  </MenuItem>
                ))}
              </Select>
              )}
            </Typography>
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              hideFooter={true}
              autoWidth={true}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              getRowId={row => row.id}
              getRowClassName={params => {
                if (params.row.index % 2 === 0) return "even";
                else return "odd";
              }}
              autoHeight={true}
              experimentalFeatures={{ newEditingApi: true }}
            />
            {errorMsg.form && (
              <Box pt={1}>
                <FormHelperText className={classes.errorStyle} error>
                  {errorMsg.form}
                </FormHelperText>
              </Box>
            )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleClose}
              >
                Done
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
